var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',[_c('v-toolbar-title',[_c('div',{staticClass:"tw-flex tw-items-center"},[_c('v-img',{attrs:{"max-width":"80","src":require("@/assets/frontline_logo.png")}})],1)]),_c('v-spacer'),_c('v-toolbar-items',[_c('v-btn',{attrs:{"text":"","color":"blue","to":"/login"}},[_vm._v(" Go to App ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }